import base from './base'
//TODO change file name to base.ts to enable typescript
export default {
    getEndpoints(productIdentifier){
        return base.get(`products/${productIdentifier}/endpoints`)
    },

    getEndpoint(endpointId) {
        return base.get(`endpoints/${endpointId}`)
    },

    getEndpointData(endpointId, params){
        return base.get(`endpoints/${endpointId}/data`, params)
    },

    getDataByteStreamResponse(dataId) {
        return base.get(`data/${dataId}/response`)
    },

    getDirectEndpointDataByteStreamResponse(directEndpointId, params) {
        return base.get(`direct_endpoints/${directEndpointId}/data`, params)
    },

    getTimelineTree(endpointId, params) {
        return base.get(`endpoints/${endpointId}/timeline_tree`, params)
    }

}